import React, {useState} from 'react';
import {object} from 'prop-types';

import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import * as SvcRequestActions from '../../actions/svcRequestActions';
import * as SiteActions from '../../actions/siteActions';

import RuleInformationModal from '../Modals/RuleInformationModal';

import classes from './HealthMonitorTableRowMenu.module.css';

const HealthMonitorTablRowMenu = ({
    onToggleCreateServiceRequestModal,
    rule,
    setSite,
    setSvcRequestRaw
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const openMenu = Boolean(anchorEl);

    const [openRuleInfoModal, setOpenRuleInfoModal] = useState(false);
 
    function handleOpenMenu(event) {
        setAnchorEl(event.currentTarget);
    }

    function handleCloseMenu() {
        setAnchorEl(null);
    }

    function handleOpenRuleInfoModal() {
        setOpenRuleInfoModal(true);
        handleCloseMenu();
    }

    function handleCloseRuleInfoModal() {
        setOpenRuleInfoModal(false);
    }

    function handleOpenCreateServiceRequestModal() {
        setSvcRequestRaw(rule);
        setSite({siteId: rule.siteId});
        onToggleCreateServiceRequestModal(true);
        handleCloseMenu();
    }

    return (
        <React.Fragment>
            <Button
                aria-owns={openMenu ? 'render-props-menu' : undefined}
                aria-haspopup="true"
                onClick={handleOpenMenu}
                className={classes.contextMenuButton}
            >
                <i className="fas fa-ellipsis-h" />
            </Button>
            <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={openMenu}
                onClose={() => { handleCloseMenu(); }}
                className={classes.contextMenu}
            >
                <MenuItem onClick={() => { handleOpenRuleInfoModal(); }}>
                    <img
                        alt=""
                        className={classes.contextIcon}
                        src="/assets/images/aboutIconColor.svg"
                    />
                    View More Info
                </MenuItem>
                {
                    process.env.serviceCallEnabled &&
                    <MenuItem onClick={() => { handleOpenCreateServiceRequestModal(); }}>
                        <img
                            alt=""
                            className={classes.contextIcon}
                            src="/assets/images/ServiceManualIconFlat.svg"
                        />
                        Create Service Request
                    </MenuItem>
                }
            </Menu>
            <RuleInformationModal
                open={openRuleInfoModal}
                onClose={() => { handleCloseRuleInfoModal(); }}
                rule={rule}
            />
        </React.Fragment>
    );
};

HealthMonitorTablRowMenu.defaultProps = {
    rule: {}
};

HealthMonitorTablRowMenu.propTypes = {
    rule: object.isRequired
};

const mapDispatchToProps = {
    ...SiteActions,
    ...SvcRequestActions,
};


export default connect(null, mapDispatchToProps)(HealthMonitorTablRowMenu);
